module.exports = __webpack_public_path__ + "img/slide-17-3.2d922dd0.png";